export default __webpack_public_path__ + "static/media/7.1fec33c0.png";